export const mutations = {
  setApprovalLevels(state, approvalLevels) {
    state.approvalLevels = approvalLevels;
  },
  resequenceApprovalLevels(state, approvalLevels) {
    approvalLevels.forEach((e, i) => (e.seq = i + 1));
    state.approvalLevels = approvalLevels;
  },
};
